/**
 * The arrow between two steps of the automation sidebar. It repeats the
 * canvas automation block's internal edge (`automation-canvas-block.ts`,
 * same geometry and colour), so the sidebar reads as the block it edits.
 */
import type { FC } from 'react';

import * as styles from './flow-connector.css';

export const FlowConnector: FC = () => (
  <div
    className={styles.connector}
    aria-hidden="true"
    data-role="automation-flow-edge"
  >
    <svg className={styles.connectorIcon} viewBox="0 0 20 38" focusable="false">
      <circle className={styles.connectorHandle} cx="10" cy="0" r="6" />
      <path className={styles.connectorShaft} d="M10 0V27" />
      <path className={styles.connectorArrowhead} d="M2 26L10 38L18 26Z" />
    </svg>
  </div>
);
